import SectionHeading from '@/components/base/SectionHeading';
import { CONTENT_PRINCIPLES } from '@/mocks/site';

export default function PrinciplesSection() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100" aria-labelledby="principles-heading">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          id="principles-heading"
          eyebrow="Principles"
          title="内容原则"
          desc="四条我们一直在遵守的原则，决定了哪些信息会被发布、哪些不会。"
        />

        <ol className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-5">
          {CONTENT_PRINCIPLES.map((p, idx) => (
            <li key={p.title} className="rounded-lg border border-background-200 bg-background-50 p-6">
              <div className="flex items-start gap-4">
                <span className="font-heading text-3xl font-bold text-background-300 leading-none">
                  {String(idx + 1).padStart(2, '0')}
                </span>
                <div>
                  <h3 className="font-heading text-lg font-semibold text-foreground-950">{p.title}</h3>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{p.text}</p>
                </div>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}